// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function image58_mouseIn(event, $w) {
	//Add your code for this event here: 
	$w('#image58').hide();
	$w('#image59').show();
}

export function image59_mouseOut(event, $w) {
	//Add your code for this event here: 
	$w('#image58').show();
	$w('#image59').hide();
}

export function image60_mouseIn(event, $w) {
	//Add your code for this event here: 
	$w('#image60').hide();
	$w('#image61').show();
}

export function image61_mouseOut(event, $w) {
	//Add your code for this event here: 
	$w('#image60').show();
	$w('#image61').hide();
}

export function text21_mouseIn(event, $w) {
	//Add your code for this event here: 
}